.msp-in-product-trials-overlay-container {
  min-height: 300px;
  max-height: 570px;
  width: 272px;
  color: var(--white-layout-300-primary);

  gz-checkbox {
    margin-top: 20px;
  }

  #msp-in-product-trials-overlay-window {
    &-image {
      width: 100%;
      height: 109px;
      object-fit: cover;
    }
    &-title {
      margin: 20px 0 16px 0;
      font-size: 18px;
    }
    &-text {
      margin-bottom: 30px;
      font-size: 13px;
      line-height: normal;
    }
  }

  gz-button {
    margin: 8px 0;
    display: block;
    font-size: 13px;
    line-height: normal;
  }
}
